import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { auth: { storage: window.sessionStorage } }
);

// Browsers throttle timers in backgrounded tabs, so Supabase's scheduled
// access-token refresh can silently miss its window if the tab sits idle
// for a while (switched away, laptop asleep, etc.). The first write after
// returning to the tab then runs on a stale token and can hang against RLS
// until it hits a client-side timeout — surfacing as a random, silent-feeling
// save failure that a fresh login always "fixes" (because that mints a new
// token). Forcing a refresh check exactly when the tab regains focus closes
// that window instead of relying on the background timer alone.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      supabase.auth.startAutoRefresh();
    } else {
      supabase.auth.stopAutoRefresh();
    }
  });
}

export default supabase;
